<div
    class="btn-group p-2 p-lg-0"
    dropdown
    #dropdown="bs-dropdown"
    [dropup]="isDropup"
    [isDisabled]="stepEntries.length === 0"
>
    @if (model?.actions?.selectedEntry; as selectedEntry) {
        @if (selectedEntry.value !== NOTIFICATION_STATUS_CODE.REMT) {
            <button
                type="button"
                (click)="onStepButtonClick(selectedEntry)"
                class="btn btn-primary btn-lg split-button px-0 me-auto"
                [disabled]="runAnimation"
            >
                @if (runAnimation) {
                    <fa-icon [icon]="faLoading" animation="spin"></fa-icon>
                }
                @if (!runAnimation) {
                    {{ selectedEntry.displayName }}
                }
            </button>
        }
    }

    @if (model?.actions?.selectedEntry; as selectedEntry) {
        @if (selectedEntry.value === NOTIFICATION_STATUS_CODE.REMT) {
            <button
                class="btn btn-primary btn-lg split-button px-0 me-auto d-lg-none d-block"
                type="button"
                [disabled]="runAnimation"
                (click)="dropdown.toggle(true)"
            >
                {{ selectedEntry.displayName }}
            </button>
        }
    }

    @if (isDropup && stepEntries.length && model.actions.selectedEntry.value !== NOTIFICATION_STATUS_CODE.REMT) {
        <button
            class="more-toggler d-lg-none btn btn-secondary btn-lg ms-2"
            type="button"
            dropdownToggle
            [attr.aria-label]="'NOTIFICATION_STATUS_STEP_BUTTON_MENU_ARIA_LABEL' | translate"
            [disabled]="runAnimation"
        >
            <fa-icon [icon]="faEllipsisV"></fa-icon>
        </button>
    }
    @if (isDropup && stepEntries.length && model.actions.selectedEntry.value === NOTIFICATION_STATUS_CODE.REMT) {
        @if (isDropup && stepEntries.length) {
            <button
                dropdown
                class="more-toggler d-lg-none btn btn-secondary btn-lg ms-2"
                type="button"
                dropdownToggle
                (click)="dropdown.toggle(true)"
                [attr.aria-label]="'NOTIFICATION_STATUS_STEP_BUTTON_MENU_ARIA_LABEL' | translate"
                [disabled]="runAnimation"
            >
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </button>
        }
    }

    @if (!isDropup && stepEntries.length) {
        <button
            type="button"
            id="button-split"
            class="btn btn-primary btn-lg dropdown-toggle dropdown-toggle-split d-lg-block d-none"
            dropdownToggle
            [attr.aria-label]="'NOTIFICATION_STATUS_STEP_BUTTON_MENU_ARIA_LABEL' | translate"
            [disabled]="runAnimation"
        >
            @if (model.actions.selectedEntry.value === NOTIFICATION_STATUS_CODE.REMT) {
                <span class="pe-3"> {{ model.actions.selectedEntry.displayName }} </span>
                <span class="caret"></span>
                <span class="visually-hidden">Toggle Dropdown</span>
            }
        </button>
    }

    <ng-container>
        <ul
            class="dropdown-menu dropdown-menu-right"
            *dropdownMenu
            id="dropdown-split"
            role="menu"
            aria-labelledby="button-split"
        >
            @for (entry of stepEntries; track entry) {
                <li [ngClass]="dimNonPriorityStatus()" role="menuitem">
                    <button
                        (click)="onStepButtonClick(entry)"
                        class="btn btn-secondary btn-lg"
                        [disabled]="disableButton(entry.model)"
                    >
                        @if (
                            entry.value === NOTIFICATION_STATUS_CODE.ROSR ||
                            entry.value === NOTIFICATION_STATUS_CODE.FCC
                        ) {
                            <fa-icon class="float-start" [icon]="faPhone" size="sm"> </fa-icon>
                        }
                        {{ entry.displayName }}
                    </button>
                </li>
            }
        </ul>
    </ng-container>
</div>
